module.exports = __webpack_public_path__ + "img/missionaries11_2019_7-7-2021.25969e62.jpg";